import connectToForm from '@frontend/jetlend-core/src/ducks/connectToForm';
import { MaskInputField } from '@frontend/jetlend-web-ui/src/ui/inputs/MaskInput/MaskInput';
import { getAssetSrc } from '@frontend/jetlend-web-ui/src/utils/getAssetSrc';
import InlinePasswordInput from '@frontend/jetlend-web-ui/src/ui/inputs/InlinePasswordInput/InlinePasswordInput';
import Link from 'next/link';
import Button from '@frontend/jetlend-web-ui/src/ui/inputs/Button/Button';
import { FormAlert } from '@frontend/jetlend-web-ui/src/ui/forms/FormAlert/FormAlert';
import phoneIcon from '@frontend/jetlend-assets/icons/icon--phone.svg';
import { useEffect } from 'react';
import useFormHandler from '@frontend/jetlend-core/src/hooks/useFormHandler';
import {
    CLIENT_TYPE_RESET_PASS_URLS,
    ClientType,
} from '@app/models/common/common';
import { getCorrectFirstPhoneNumberFigure } from '@app/utils/getCorrectFirstPhoneNumberFigure';
import { commonLoginFormHandler } from '@app/ducks/common/login';

import styles from './StageHasAccount.module.scss';

/**
 * Компонент контента модального окна прескоринга на стадии Has Account
 * (если пользователь уже зарегистрирован на платформе)
 */
export default connectToForm(function StageHasAccount({
    handleSubmit,
    formSubmitting,
    invalid,
    error,
    dirty,
}) {
    const form = useFormHandler(commonLoginFormHandler);

    useEffect(() => {
        form.initialize({
            clientType: ClientType.BORROWER,
        });
    }, [ form ]);

    return (
        <div className={styles['content']}>
            <h2 className={styles['title']} data-testid="limit-prescoring-modal__title">
                Добро пожаловать!
            </h2>
            <div className={styles['subtitle']}>
                Ваш ИНН уже зарегистрирован, войдите в аккаунт
            </div>
            <div className={styles['input']}>
                <div className={styles['field']}>
                    <MaskInputField
                        name="phone"
                        label="Номер телефона"
                        mask="+7 000 000-00-00"
                        prepareChar={getCorrectFirstPhoneNumberFigure}
                        inputType="tel"
                        autoComplete="tel"
                        autoFocus
                        icon={getAssetSrc(phoneIcon)}
                        disabled={formSubmitting}
                    />

                    <InlinePasswordInput
                        label="Пароль"
                        name="password"
                        autoComplete="current-password"
                        disabled={formSubmitting}
                    />

                    <div className={styles['footer']}>
                        <div className={styles['remind']}>
                            <Link href={CLIENT_TYPE_RESET_PASS_URLS['borrower']}>Забыли пароль или номер?</Link>
                        </div>
                    </div>
                </div>
            </div>

            <Button
                className={styles['button']}
                buttonType="submit"
                text="Войти"
                width="100%"
                containerClassName={styles['button-container']}
                disabled={invalid || !dirty}
                loading={formSubmitting}
                onClick={handleSubmit}
                noSpacing
                type="primary"
            />

            <FormAlert className="h-mt-10 h-width--full" alert={error} />

            <div className={styles['legal']}>
                <div>
                    Ввод номера телефона подтверждает ваше согласие с{' '}
                    <Link href="/doc-view/rules" target="_blank">правилами платформы</Link>{' '}
                    и&nbsp;
                    <Link href="/doc-view/privacy" target="_blank">
                        политикой&nbsp;обработки персональных данных
                    </Link>
                </div>
            </div>
        </div>
    );
}, commonLoginFormHandler);